export const disturbanceOptions = [
  { key: 'cancelled', value: 'cancelled', text: 'cancelled' },
  { key: 'delayed', value: 'delayed', text: 'delayed' },
  { key: 'overbooked', value: 'overbooked', text: 'overbooked' }
];



// WEBPACK FOOTER //
// ./src/options/disturbanceOptions.js